import { motion } from "framer-motion";

const FadeIn = ({
    children,
    delay = 0,
    y = 20,
    duration = 1.2,
    className = "",
    once = true,
    ...props
}) => {
    return (
        <motion.div
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once, margin: "-80px" }}
            transition={{
                duration,
                delay,
                ease: [0.16, 1, 0.3, 1],
            }}
            className={className}
            {...props}
        >
            {children}
        </motion.div>
    );
};

export default FadeIn;
